module.exports = __webpack_public_path__ + "static/img/solution.aa86551.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/solution.png
// module id = BWCO
// module chunks = 0